import {ACTION_TYPES, COMPONENT_STATES} from "../../../core/consts";
import {RelatedEntitiesWidgetController} from "../related-entities-widget.controller";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {RelatedEntitiesWidgetState} from "../models/related-entities-widget.state";
import {RelatedEntitiesRequestParams} from "../../../domain/related-entities/models/related-entities.request-params";
import {RelatedEntitiesDomainService} from "../../../domain/related-entities/services/related-entities-domain-service";
import {EntitiesResponseDomainModel} from "../../../domain/entities/models/entities.response-domain-model";

export class RelatedEntitiesWidgetFetchHandler extends FetchHandler {
  controller: RelatedEntitiesWidgetController;
  state: RelatedEntitiesWidgetState;

  static injectables = [RelatedEntitiesDomainService];


  onLoaded() {
    super.onLoaded();

    this.action();
  }

  get requestParams(): RelatedEntitiesRequestParams {
    const competitions = this.controller.props.competitionId ? [this.controller.props.competitionId] : null;
    const competitors = this.controller.props.competitorId ? [this.controller.props.competitorId] : null;
    const athletes = this.controller.props.athleteId ? [this.controller.props.athleteId] : null;

    const requestParams: RelatedEntitiesRequestParams = new RelatedEntitiesRequestParams(competitions, competitors, athletes);

    return requestParams;
  }

  async action() {
    const dataSource: EntitiesResponseDomainModel = await this.fetch();

    await this.controller.action(ACTION_TYPES.populateData, {dataSource});

    this.store.setComponentState(COMPONENT_STATES.loaded);

    return dataSource;
  }

  async onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const isCompetitorChanged: Boolean = prevProps?.competitorId !== nextProps?.competitorId;
    const isCompetitionChanged: Boolean = prevProps?.competitionId !== nextProps?.competitionId;
    const isAthleteChanged: Boolean = prevProps?.athleteId !== nextProps?.athleteId;

    if (isCompetitorChanged || isCompetitionChanged || isAthleteChanged) {
      this.state.componentState = COMPONENT_STATES.loading;

      await this.action();
    }
  }
}
